export const GRID_TAG = 'apex-grid' as const;
export const GRID_BODY = 'apex-virtualizer' as const;
export const GRID_HEADER_ROW_TAG = 'apex-grid-header-row' as const;
export const GRID_HEADER_TAG = 'apex-grid-header' as const;
export const GRID_ROW_TAG = 'apex-grid-row' as const;
export const GRID_CELL_TAG = 'apex-grid-cell' as const;
export const GRID_FILTER_ROW_TAG = 'apex-filter-row' as const;
export const GRID_PAGINATOR_TAG = 'apex-grid-paginator' as const;
export const GRID_TOOLBAR_TAG = 'apex-grid-toolbar' as const;
